export const PaymentMethodExplanation = {
  cash: '薬局レジで決済を行います。MEDIXSかかりつけ支援にて請求金額を管理したい場合は金額を入力してください。会計しても、患者へ通知されません',
  app: '患者がmelmoに登録したクレジットカード情報で決済を行います。会計後、患者に決済完了したことが通知されます',
};
